/* ==========================================================================
   HERO MATRIX INTERACTION MODULE WITH TIMER PROGRESS BAR
   ========================================================================== */

export function initHeroMatrix() {
  const chips = document.querySelectorAll('.expertise-chip');
  let currentIndex = 0;
  let timer = null;

  if (chips.length === 0) return;

  // Add progress bar elements to chips if not present
  chips.forEach(chip => {
    if (!chip.querySelector('.chip-progress-bar')) {
      const progressBar = document.createElement('div');
      progressBar.className = 'chip-progress-bar';
      progressBar.innerHTML = '<div class="chip-progress-fill"></div>';
      chip.appendChild(progressBar);
    }
  });

  function setActiveChip(index) {
    chips.forEach((c, idx) => {
      if (idx === index) {
        c.classList.add('active');
        // Restart CSS animation
        const fill = c.querySelector('.chip-progress-fill');
        if (fill) {
          fill.style.animation = 'none';
          fill.offsetHeight; // trigger reflow
          fill.style.animation = 'chip-progress 3.5s linear forwards';
        }
      } else {
        c.classList.remove('active');
      }
    });
    currentIndex = index;
  }

  function startRotation() {
    stopRotation();
    setActiveChip(currentIndex);
    timer = setInterval(() => {
      const nextIndex = (currentIndex + 1) % chips.length;
      setActiveChip(nextIndex);
    }, 3500);
  }

  function stopRotation() {
    if (timer) clearInterval(timer);
  }

  // Initial active state
  setActiveChip(0);
  startRotation();

  // Manual chip interaction
  chips.forEach((chip, idx) => {
    chip.addEventListener('click', () => {
      stopRotation();
      setActiveChip(idx);
    });
  });
}
